import http from './api'

const route = 'app/comercial/compras/'

export default {
    showComprasSpot: (primeiroDia, ultimoDia, empresaSelect, tokenContrato) => {
        return http.post(route + 'showComprasSpot', {
          dataInicio: primeiroDia,
          dataFim: ultimoDia,
          empresa: empresaSelect,
          tokenContrato: tokenContrato,
        })
    },
}
